const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://qlaqb4ozpva6pbxecqiln4nxky.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-bmz5dyqpavbehfdhsxyi7sval4"
};

export default awsmobile;
